import "text-encoding-polyfill";
import Joi from "joi";

const sendEmailSchema = Joi.object({
	email: Joi.string()
		.email({
			tlds: false,
		})
		.required(),
});

export default sendEmailSchema;
